export default __webpack_public_path__ + "static/portal/img/map3.60ffda2.png";